export type PushNotificationSupportParamsInit = {
  enabledPlatforms?: Array<string>;
  webPushConfig?: string;
  publicVapidKey?: string;
  isCustomer?: boolean | string;
  isEmployee?: boolean;
};

export default class PushNotificationSupportParams {
  enabledPlatforms: Array<string> = [];

  webPushConfig = '';

  publicVapidKey = '';

  isCustomer: boolean | string = false;

  isEmployee = false;

  constructor(init: PushNotificationSupportParamsInit = {}) {
    Object.assign(this, init);
  }
}
